// Fixed-panel minimum widths (px). Used both as panel minSize values and as the
// floor for the group's overflow min-width (see useFixedPanelsGroupMinWidth).
export const SIDEBAR_MIN_WIDTH = 240;
export const SEARCH_OPTIONS_MIN_WIDTH = 240;
export const INSPECTOR_MIN_WIDTH = 340;
export const INSPECTOR_DEFAULT_SIZE_PERCENT = 20;
// 14rem grid-column floor (224px) + grid p-6 gutters (48px) = one full tile column visible.
export const MAIN_CONTENT_MIN_WIDTH = 272;
